import React from 'react';
import { PuckRenderer, SidePanel } from 'components/synchrotron';
import { IStyle } from 'Styles';
function index() {
  return (
    <div id="synchrotron-index-main-container">
      <PuckRenderer disabled={false} />
      <div id="synchrotron-index-sidepanel" style={styles.sidePanelRoot}>
        <SidePanel />
      </div>
    </div>
  );
}

const styles: IStyle = {
  sidePanelRoot: {
    position: 'fixed',
    display: 'block',
    width: `${30 - 1}%`,
    height: '89.5%',
    top: '10.5%',
    left: `${101 - 30}%`,
    right: 0,
    bottom: 0,
    borderLeft: '1px solid lightGray',
    backgroundColor: 'white',
  },
};
export default index;
